// 订单码洋同比模块
const state = {
  // 订单数及码洋同比
  orderComparison: {
    dates: [],
    orders: [],
    amounts: []
  }
}

const mutations = {
  // 设置订单码洋同比数据
  SET_ORDER_COMPARISON(state, data) {
    state.orderComparison = data
  },
  // 重置订单码洋同比数据
  RESET_ORDER(state) {
    state.orderComparison = {
      dates: [],
      orders: [],
      amounts: []
    }
  }
}

const actions = {
  // 获取订单码洋同比数据（使用大屏 dingdan 字段派生：以2025年zhou字段作为基准x轴点，仅匹配zhou_2字段中同期数据）
  async fetchOrderComparison({ commit, rootState }) {
    try {
      const big = rootState.screen.screenData || {}
      const list = Array.isArray(big.dingdan) ? big.dingdan : []
      const safeNum = (v) => {
        const n = Number(v)
        return isNaN(n) ? 0 : n
      }

      // 首先收集所有2025年的zhou字段作为基准x轴点
      const baselineWeeks = new Set()
      const weekMapping = new Map() // zhou -> zhou_2 的映射关系
      const currentYearData = new Map() // zhou -> { amount, orders }
      const lastYearData = new Map() // zhou_2 -> { amount, orders }

      // 收集2025年数据作为基准
      for (const item of list) {
        const year = Number(item?.nian)
        const week = Number(item?.zhou)
        const week2 = Number(item?.zhou_2)
        
        if (year === 2025 && week) {
          baselineWeeks.add(week)
          if (week2) {
            weekMapping.set(week, week2) // 建立zhou到zhou_2的映射
          }
          currentYearData.set(week, {
            amount: safeNum(item?.mayang),
            orders: safeNum(item?.sl)
          })
        }
        
        // 收集2024年数据，使用zhou_2字段
        if (year === 2024 && week2) {
          lastYearData.set(week2, {
            amount: safeNum(item?.mayang),
            orders: safeNum(item?.sl)
          })
        }
      }

      // 计算周区间标签（以 2025 年为基准，ISO 8601：周一为一周起始，周日为结束）
      const isoWeekMonday = (year, week) => {
        const jan4 = new Date(Date.UTC(year, 0, 4))
        const jan4Dow = (jan4.getUTCDay() + 6) % 7 // 0=Mon..6=Sun
        const mondayWeek1 = new Date(jan4)
        mondayWeek1.setUTCDate(jan4.getUTCDate() - jan4Dow)
        const mondayOfWeek = new Date(mondayWeek1)
        mondayOfWeek.setUTCDate(mondayWeek1.getUTCDate() + (week - 1) * 7)
        return mondayOfWeek
      }
      const fmt = (d) => {
        const y = d.getUTCFullYear()
        const m = d.getUTCMonth() + 1
        const day = d.getUTCDate()
        return `${y}.${m}.${day < 10 ? '0' + day : day}`
      }

      // 仅处理2025年基准周数，并尝试匹配zhou_2字段中的同期数据
      const sortedWeeks = Array.from(baselineWeeks).sort((a, b) => a - b)
      const dates = []
      const orders = []
      const amounts = []
      
      for (const week of sortedWeeks) {
        const currentData = currentYearData.get(week)
        const matchWeek2 = weekMapping.get(week) // 获取对应的zhou_2值
        const lastData = matchWeek2 ? lastYearData.get(matchWeek2) : null // 使用映射的zhou_2值查找去年数据
        
        // 只有当前年数据存在时才添加到结果中（基准要求）
        if (currentData) {
          // 生成周区间标签
          const startMon = isoWeekMonday(2025, week)
          const endSun = new Date(startMon)
          endSun.setUTCDate(startMon.getUTCDate() + 6)
          dates.push(`${fmt(startMon)}~${fmt(endSun)}`)
          
          // 添加数据，如果zhou_2中没有匹配的数据则为0
          orders.push({ 
            currentYear: currentData.orders, 
            lastYear: lastData ? lastData.orders : 0 
          })
          amounts.push({ 
            currentYear: currentData.amount, 
            lastYear: lastData ? lastData.amount : 0 
          })
        }
      }

      commit('SET_ORDER_COMPARISON', { dates, orders, amounts })
    } catch (error) {
      console.error('获取订单码洋同比数据失败:', error)
      commit('SET_ORDER_COMPARISON', { dates: [], orders: [], amounts: [] })
    }
  }
}

const getters = {
  orderComparison: state => state.orderComparison
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
